import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";
import * as format from "../../common/FormatFunctions";

export class CreateSets extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      instructorList: "",
      selectedSetInstructors: "",
      serviceList: "",
      setStartDate: "",
      setNumberOfWeeks: "",
      setService: "",
      setId: "",
      setInstructorNames: "",
      setMaxNumberOfParticipants: "",
      setRoom: "",
      roomList: [],
      roomOptions: [],
      //Monday
      classOnMonday: false,
      mondayStart: "",
      mondayEnd: "",
      mondayClosed: false,
      //Tuesday
      classOnTuesday: false,
      tuesdayStart: "",
      tuesdayEnd: "",
      tuesdayClosed: false,
      //Wednesday
      classOnWednesday: false,
      wednesdayStart: "",
      wednesdayEnd: "",
      wednesdayClosed: false,
      //Thursday
      classOnThursday: false,
      thursdayStart: "",
      thursdayEnd: "",
      thursdayClosed: false,
      //Friday
      classOnFriday: false,
      fridayStart: "",
      fridayEnd: "",
      fridayClosed: false,
      //Saturday
      classOnSaturday: false,
      saturdayStart: "",
      saturdayEnd: "",
      saturdayClosed: false,
      //Sunday
      classOnSunday: false,
      sundayStart: "",
      sundayEnd: "",
      sundayClosed: false,
      pickListAvailable: [],
      pickListSelected: []
    };
  }

  componentDidMount = () => {
    if (localStorage.getItem("businessOpeningHours")) {
      let days = JSON.parse(localStorage.getItem("businessOpeningHours"))
        .daysOpeningHours;
      let mondayStartBusiness = days.MONDAY[0];
      let mondayEndBusiness = days.MONDAY[1];
      let tuesdayStartBusiness = days.TUESDAY[0];
      let tuesdayEndBusiness = days.TUESDAY[1];
      let wednesdayStartBusiness = days.WEDNESDAY[0];
      let wednesdayEndBusiness = days.WEDNESDAY[1];
      let thursdayStartBusiness = days.THURSDAY[0];
      let thursdayEndBusiness = days.THURSDAY[1];
      let fridayStartBusiness = days.FRIDAY[0];
      let fridayEndBusiness = days.FRIDAY[1];
      let saturdayStartBusiness = days.SATURDAY[0];
      let saturdayEndBusiness = days.SATURDAY[1];
      let sundayStartBusiness = days.SUNDAY[0];
      let sundayEndBusiness = days.SUNDAY[1];

      if (mondayStartBusiness === 1110 && mondayEndBusiness === 1111) {
        this.setState({ mondayClosed: true });
      } else {
        this.setState({ mondayClosed: false });
      }

      if (tuesdayStartBusiness === 1110 && tuesdayEndBusiness === 1111) {
        this.setState({ tuesdayClosed: true });
      } else {
        this.setState({ tuesdayClosed: false });
      }

      if (wednesdayStartBusiness === 1110 && wednesdayEndBusiness === 1111) {
        this.setState({ wednesdayClosed: true });
      } else {
        this.setState({ wednesdayClosed: false });
      }

      if (thursdayStartBusiness === 1110 && thursdayEndBusiness === 1111) {
        this.setState({ thursdayClosed: true });
      } else {
        this.setState({ thursdayClosed: false });
      }

      if (fridayStartBusiness === 1110 && fridayEndBusiness === 1111) {
        this.setState({ fridayClosed: true });
      } else {
        this.setState({ fridayClosed: false });
      }

      if (saturdayStartBusiness === 1110 && saturdayEndBusiness === 1111) {
        this.setState({ saturdayClosed: true });
      } else {
        this.setState({ saturdayClosed: false });
      }

      if (sundayStartBusiness === 1110 && sundayEndBusiness === 1111) {
        this.setState({ sundayClosed: true });
      } else {
        this.setState({ sundayClosed: false });
      }

      if (localStorage.getItem("reCreate") === "true") {
        this.setState(
          {
            setService: localStorage.getItem("reCreateServiceId"),
            setId: localStorage.getItem("reCreateSetId"),
            setMaxNumberOfParticipants: localStorage.getItem(
              "reCreateMaxParticipants"
            ),
            setRoom: localStorage.getItem("reCreateRoomId"),
            pickListSelected: JSON.parse(
              localStorage.getItem("reCreatePickedInstructors")
            )
          },
          () => {
            localStorage.setItem("reCreate", false);
          }
        );
        var mondayTime = localStorage.getItem("reCreateMondayTime");
        if (format.isNotNull(mondayTime)) {
          let timesArray = mondayTime.split(",");
          let dayS = timesArray[0];
          let dayE = timesArray[1];
          let startDate = format.formatDateFromTime(dayS);
          let endDate = format.formatDateFromTime(dayE);
          this.setState({
            classOnMonday: true,
            mondayStart: startDate,
            mondayEnd: endDate
          });
        }
        var tuesdayTime = localStorage.getItem("reCreateTuesdayTime");
        if (format.isNotNull(tuesdayTime)) {
          let timesArray = tuesdayTime.split(",");
          let dayS = timesArray[0];
          let dayE = timesArray[1];
          let startDate = format.formatDateFromTime(dayS);
          let endDate = format.formatDateFromTime(dayE);
          this.setState({
            classOnTuesday: true,
            tuesdayStart: startDate,
            tuesdayEnd: endDate
          });
        }
        var wednesdayTime = localStorage.getItem("reCreateWednesdayTime");
        if (format.isNotNull(wednesdayTime)) {
          let timesArray = wednesdayTime.split(",");
          let dayS = timesArray[0];
          let dayE = timesArray[1];
          let startDate = format.formatDateFromTime(dayS);
          let endDate = format.formatDateFromTime(dayE);
          this.setState({
            classOnWednesday: true,
            wednesdayStart: startDate,
            wednesdayEnd: endDate
          });
        }
        var thursdayTime = localStorage.getItem("reCreateThursdayTime");
        if (format.isNotNull(thursdayTime)) {
          let timesArray = thursdayTime.split(",");
          let dayS = timesArray[0];
          let dayE = timesArray[1];
          let startDate = format.formatDateFromTime(dayS);
          let endDate = format.formatDateFromTime(dayE);
          this.setState({
            classOnThursday: true,
            thursdayStart: startDate,
            thursdayEnd: endDate
          });
        }
        var fridayTime = localStorage.getItem("reCreateFridayTime");
        if (format.isNotNull(fridayTime)) {
          let timesArray = fridayTime.split(",");
          let dayS = timesArray[0];
          let dayE = timesArray[1];
          let startDate = format.formatDateFromTime(dayS);
          let endDate = format.formatDateFromTime(dayE);
          this.setState({
            classOnFriday: true,
            fridayStart: startDate,
            fridayEnd: endDate
          });
        }
        var saturdayTime = localStorage.getItem("reCreateSaturdayTime");
        if (format.isNotNull(saturdayTime)) {
          let timesArray = saturdayTime.split(",");
          let dayS = timesArray[0];
          let dayE = timesArray[1];
          let startDate = format.formatDateFromTime(dayS);
          let endDate = format.formatDateFromTime(dayE);
          this.setState({
            classOnSaturday: true,
            saturdayStart: startDate,
            saturdayEnd: endDate
          });
        }
        var sundayTime = localStorage.getItem("reCreateSundayTime");
        if (format.isNotNull(sundayTime)) {
          let timesArray = sundayTime.split(",");
          let dayS = timesArray[0];
          let dayE = timesArray[1];
          let startDate = format.formatDateFromTime(dayS);
          let endDate = format.formatDateFromTime(dayE);
          this.setState({
            classOnSunday: true,
            sundayStart: startDate,
            sundayEnd: endDate
          });
        }
      }

      this.getRooms();
      this.getInstructors();
      this.getServices();
    } else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "An error occured, please refresh and try again",
        life: 3000
      });
    }
  };

  getRooms = async () => {
    let roomRequest = new Belfastpilatesappspotcom.RoomRequest();
    roomRequest.codeTag = localStorage.getItem("globalBid");
    roomRequest.userId = localStorage.getItem("userId");

    await api("roomApiV1RoomGetByCodeTag", roomRequest).then(res => {
      if (res.data) {
        if (Array.isArray(res.data.roomList)) {
          res.data.roomList.forEach(e => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let roomResponse = Belfastpilatesappspotcom.RoomResponse.constructFromObject(
          res.data
        );
        console.log(roomResponse);

        if (roomResponse.errorCode === 0) {
          this.setState({ roomList: roomResponse.roomList }, () => {
            this.roomsToOptions();
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Rooms could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("roomApiV1RoomGetByCodeTag has failed");
      }
    });
  };

  roomsToOptions = () => {
    let roomArray = [];

    if (Array.isArray(this.state.roomList)) {
      this.state.roomList.forEach(e => {
        roomArray.push({ label: e.name, value: e.id });
      });
    }

    this.setState({ roomOptions: roomArray });
  };

  async getInstructors() {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");

    await api("userApiV1UserListInBusiness", userRequest).then(res => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let userResponse = Belfastpilatesappspotcom.UserResponse.constructFromObject(
          res.data
        );
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            instructorList: userResponse.users,
            pickListAvailable: userResponse.users
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Instructors could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("userApiV1UserListInBusiness has failed");
      }
    });
  }

  async getServices() {
    this.setState({ loaded: false });

    let serviceRequest = new Belfastpilatesappspotcom.ServiceRequest();
    serviceRequest.codeTag = localStorage.getItem("globalBid");

    await api("serviceApiV1ServiceGetByCodeTag", serviceRequest).then(res => {
      if (res.data) {
        let serviceResponse = Belfastpilatesappspotcom.ServiceResponse.constructFromObject(
          res.data
        );
        console.log(serviceResponse);

        if (serviceResponse.errorCode === 0) {
          this.setState({
            serviceList: serviceResponse.serviceList
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Services could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("serviceApiV1ServiceGetByCodeTag has failed");
      }
    });

    this.setState({ loaded: true });
  }

  getServiceOptions = () => {
    let serviceArray = [];
    let i = 0;

    if (Array.isArray(this.state.serviceList)) {
      this.state.serviceList.forEach(e => {
        serviceArray[i] = { label: e.name, value: e.id };
        i++;
      });
    }

    return serviceArray;
  };

  createSchedule = async ids => {
    if (
      this.state.setStartDate &&
      this.state.setNumberOfWeeks &&
      this.state.setMaxNumberOfParticipants &&
      this.state.setService
    ) {
      let idArray = [];

      let scheduleRequest = new Belfastpilatesappspotcom.ScheduleRequest();
      scheduleRequest.codeTag = localStorage.getItem("globalBid");
      scheduleRequest.userId = localStorage.getItem("userId");
      scheduleRequest.countryCode = localStorage.getItem("countryCode");
      scheduleRequest.generateStartDate = this.state.setStartDate;
      scheduleRequest.numberOfDaysToGenerate = this.state.setNumberOfWeeks * 7;
      scheduleRequest.maxSpace = this.state.setMaxNumberOfParticipants;
      scheduleRequest.serviceId = this.state.setService;
      scheduleRequest.setId = this.state.setId;
      scheduleRequest.system = "BOOKING";
      scheduleRequest.recurrenceType = "WEEKLY";
      scheduleRequest.setsRequired = true;
      scheduleRequest.roomId = this.state.setRoom;
      scheduleRequest.endAfterRecurrences = this.state.setNumberOfWeeks;
      if (ids) {
        scheduleRequest.instructorIds = ids;
      }
      if (Array.isArray(this.state.pickListSelected)) {
        let onlyOneUser = false;
        this.state.pickListSelected.forEach(e => {
          if (!onlyOneUser) {
            idArray.push(e.id);
            onlyOneUser = true;
          } else {
            return;
          }
        });
        scheduleRequest.instructorIds = idArray;
        console.log("Original userId - " + scheduleRequest.userId);
        // override the userId to enable the correct user for employee availability
        scheduleRequest.userId = idArray[0];
        console.log("New userId - " + scheduleRequest.userId);
      }
      if (this.state.classOnMonday === true) {
        scheduleRequest.monday = "MONDAY";
        scheduleRequest.mondayTime = [
          this.state.mondayStart,
          this.state.mondayEnd
        ];
      }
      if (this.state.classOnTuesday === true) {
        scheduleRequest.tuesday = "TUESDAY";
        scheduleRequest.tuesdayTime = [
          this.state.tuesdayStart,
          this.state.tuesdayEnd
        ];
      }
      if (this.state.classOnWednesday === true) {
        scheduleRequest.wednesday = "WEDNESDAY";
        scheduleRequest.wednesdayTime = [
          this.state.wednesdayStart,
          this.state.wednesdayEnd
        ];
      }
      if (this.state.classOnThursday === true) {
        scheduleRequest.thursday = "THURSDAY";
        scheduleRequest.thursdayTime = [
          this.state.thursdayStart,
          this.state.thursdayEnd
        ];
      }
      if (this.state.classOnFriday === true) {
        scheduleRequest.friday = "FRIDAY";
        scheduleRequest.fridayTime = [
          this.state.fridayStart,
          this.state.fridayEnd
        ];
      }
      if (this.state.classOnSaturday === true) {
        scheduleRequest.saturday = "SATURDAY";
        scheduleRequest.saturdayTime = [
          this.state.saturdayStart,
          this.state.saturdayEnd
        ];
      }
      if (this.state.classOnSunday === true) {
        scheduleRequest.sunday = "SUNDAY";
        scheduleRequest.sundayTime = [
          this.state.sundayStart,
          this.state.sundayEnd
        ];
      }

      if (this.state.setId) {
        // re-creating set
        await api("scheduleApiV1ScheduleRecreate", scheduleRequest).then(
          res => {
            if (res.data) {
              let scheduleResponse = Belfastpilatesappspotcom.ScheduleResponse.constructFromObject(
                res.data
              );
              console.log(scheduleResponse);

              if (scheduleResponse.errorCode === 0) {
                this.setState({ loaded: true });
                window.location = "/#/managesets";
              } else if (scheduleResponse.errorCode === 21101) {
                this.growl.show({
                  severity: "error",
                  summary: "Error",
                  detail: "Too many booked users for max space allocated",
                  life: 3000
                });
                this.setState({ loaded: true });
              } else {
                this.growl.show({
                  severity: "error",
                  summary: "Error",
                  detail: "Schedule could not be recreated, please try again",
                  life: 3000
                });
                this.setState({ loaded: true });
              }
            } else {
              console.log("scheduleApiV1ScheduleRecreate has failed");
              this.growl.show({
                severity: "error",
                summary: "Error",
                detail:
                  "Oops! Something unexpected happened. Your schedule may have been re-created. Please check",
                life: 3000
              });
              window.location = "/#/managesets";
            }
          }
        );
        this.setState({ loaded: true });
      } else {
        // creating set
        await api("scheduleApiV1ScheduleCreate", scheduleRequest).then(res => {
          if (res.data) {
            let scheduleResponse = Belfastpilatesappspotcom.ScheduleResponse.constructFromObject(
              res.data
            );
            console.log(scheduleResponse);

            if (scheduleResponse.errorCode === 0) {
              this.setState({ loaded: true });
              window.location = "/#/managesets";
            } else {
              this.growl.show({
                severity: "error",
                summary: "Error",
                detail: "Schedule could not be created, please try again",
                life: 3000
              });
            }
          } else {
            console.log("scheduleApiV1ScheduleCreate has failed");
          }
        });
      }
      this.setState({ loaded: true });
    } else {
      this.growl.show({
        severity: "error",
        summary: "Missing Fields",
        detail: "Please fill in all fields",
        life: 3000
      });
      this.setState({ loaded: true });
    }
  };

  render() {
    const serviceOptions = this.getServiceOptions();

    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <div className="ui-g-12">
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />
          <div className="card">
            <div className="ui-g">
              <div className="ui-g-12">
                {this.state.setId ? (
                  <h1>Re-Create Set</h1>
                ) : (
                  <h1>Create New Set</h1>
                )}
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <pr.Calendar
                      placeholder="Start Date"
                      value={this.state.setStartDate}
                      onChange={e => this.setState({ setStartDate: e.value })}
                      showTime={true}
                      showSeconds={true}
                      dateFormat="dd/mm/yy"
                    />
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.setNumberOfWeeks === ""
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.setNumberOfWeeks}
                        onKeyPress={e => {
                          this.growl.clear();
                          if (
                            e.charCode !== 48 &&
                            e.charCode !== 49 &&
                            e.charCode !== 50 &&
                            e.charCode !== 51 &&
                            e.charCode !== 52 &&
                            e.charCode !== 53 &&
                            e.charCode !== 54 &&
                            e.charCode !== 55 &&
                            e.charCode !== 56 &&
                            e.charCode !== 57
                          ) {
                            this.growl.show({
                              severity: "error",
                              summary: "Error",
                              detail: "Do not enter text",
                              life: 3000
                            });
                          }
                        }}
                        onChange={e =>
                          this.setState({ setNumberOfWeeks: e.target.value })
                        }
                      />
                      <label>No. of Weeks to Generate</label>
                    </span>
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.setMaxNumberOfParticipants === ""
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.setMaxNumberOfParticipants}
                        onKeyPress={e => {
                          this.growl.clear();
                          if (
                            e.charCode !== 48 &&
                            e.charCode !== 49 &&
                            e.charCode !== 50 &&
                            e.charCode !== 51 &&
                            e.charCode !== 52 &&
                            e.charCode !== 53 &&
                            e.charCode !== 54 &&
                            e.charCode !== 55 &&
                            e.charCode !== 56 &&
                            e.charCode !== 57
                          ) {
                            this.growl.show({
                              severity: "error",
                              summary: "Error",
                              detail: "Do not enter text",
                              life: 3000
                            });
                          }
                        }}
                        onChange={e =>
                          this.setState({
                            setMaxNumberOfParticipants: e.target.value
                          })
                        }
                      />
                      <label>Max Number of Participants</label>
                    </span>
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                    <div className="ui-g-6">
                      {this.state.mondayClosed ? (
                        <label />
                      ) : (
                        <div className="ui-g-12">
                          <div className="ui-g-6">
                            <b>Monday</b>
                          </div>
                          <div className="ui-g-6">
                            <center>
                              <pr.Checkbox
                                onChange={e =>
                                  this.setState({ classOnMonday: e.checked })
                                }
                                checked={this.state.classOnMonday}
                                style={{ align: "middle" }}
                              />
                            </center>
                          </div>
                        </div>
                      )}
                      {this.state.tuesdayClosed ? (
                        <label />
                      ) : (
                        <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                          <div className="ui-g-6">
                            <b>Tuesday</b>
                          </div>
                          <div className="ui-g-6">
                            <center>
                              <pr.Checkbox
                                onChange={e =>
                                  this.setState({ classOnTuesday: e.checked })
                                }
                                checked={this.state.classOnTuesday}
                                style={{ align: "middle" }}
                              />
                            </center>
                          </div>
                        </div>
                      )}
                      {this.state.wednesdayClosed ? (
                        <label />
                      ) : (
                        <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                          <div className="ui-g-6">
                            <b>Wednesday</b>
                          </div>
                          <div className="ui-g-6">
                            <center>
                              <pr.Checkbox
                                onChange={e =>
                                  this.setState({ classOnWednesday: e.checked })
                                }
                                checked={this.state.classOnWednesday}
                                style={{ align: "middle" }}
                              />
                            </center>
                          </div>
                        </div>
                      )}
                      {this.state.thursdayClosed ? (
                        <label />
                      ) : (
                        <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                          <div className="ui-g-6">
                            <b>Thursday</b>
                          </div>
                          <div className="ui-g-6">
                            <center>
                              <pr.Checkbox
                                onChange={e =>
                                  this.setState({ classOnThursday: e.checked })
                                }
                                checked={this.state.classOnThursday}
                                style={{ align: "middle" }}
                              />
                            </center>
                          </div>
                        </div>
                      )}
                      {this.state.fridayClosed ? (
                        <label />
                      ) : (
                        <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                          <div className="ui-g-6">
                            <b>Friday</b>
                          </div>
                          <div className="ui-g-6">
                            <center>
                              <pr.Checkbox
                                onChange={e =>
                                  this.setState({ classOnFriday: e.checked })
                                }
                                checked={this.state.classOnFriday}
                                style={{ align: "middle" }}
                              />
                            </center>
                          </div>
                        </div>
                      )}
                      {this.state.saturdayClosed ? (
                        <label />
                      ) : (
                        <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                          <div className="ui-g-6">
                            <b>Saturday</b>
                          </div>
                          <div className="ui-g-6">
                            <center>
                              <pr.Checkbox
                                onChange={e =>
                                  this.setState({ classOnSaturday: e.checked })
                                }
                                checked={this.state.classOnSaturday}
                                style={{ align: "middle" }}
                              />
                            </center>
                          </div>
                        </div>
                      )}
                      {this.state.sundayClosed ? (
                        <label />
                      ) : (
                        <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                          <div className="ui-g-6">
                            <b>Sunday</b>
                          </div>
                          <div className="ui-g-6">
                            <center>
                              <pr.Checkbox
                                onChange={e =>
                                  this.setState({ classOnSunday: e.checked })
                                }
                                checked={this.state.classOnSunday}
                                style={{ align: "middle" }}
                              />
                            </center>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="ui-g-6">
                      <div className="ui-g-12">
                        {!this.state.classOnMonday ? (
                          <div
                            className="ui-g-12"
                            style={{ pointerEvents: "none" }}
                          >
                            <input
                              style={{
                                borderLeftStyle: "hidden",
                                borderColor: "white"
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.mondayStart || ""}
                                onChange={e => {
                                  this.setState({ mondayStart: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="Start"
                              />
                            </div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.mondayEnd || ""}
                                onChange={e => {
                                  this.setState({ mondayEnd: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="End"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="ui-g-12">
                        {!this.state.classOnTuesday ? (
                          <div
                            className="ui-g-12"
                            style={{ pointerEvents: "none" }}
                          >
                            <input
                              style={{
                                borderLeftStyle: "hidden",
                                borderColor: "white"
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.tuesdayStart || ""}
                                onChange={e => {
                                  this.setState({ tuesdayStart: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="Start"
                              />
                            </div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.tuesdayEnd || ""}
                                onChange={e => {
                                  this.setState({ tuesdayEnd: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="End"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="ui-g-12">
                        {!this.state.classOnWednesday ? (
                          <div
                            className="ui-g-12"
                            style={{ pointerEvents: "none" }}
                          >
                            <input
                              style={{
                                borderLeftStyle: "hidden",
                                borderColor: "white"
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.wednesdayStart || ""}
                                onChange={e => {
                                  this.setState({ wednesdayStart: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="Start"
                              />
                            </div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.wednesdayEnd || ""}
                                onChange={e => {
                                  this.setState({ wednesdayEnd: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="End"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="ui-g-12">
                        {!this.state.classOnThursday ? (
                          <div
                            className="ui-g-12"
                            style={{ pointerEvents: "none" }}
                          >
                            <input
                              style={{
                                borderLeftStyle: "hidden",
                                borderColor: "white"
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.thursdayStart || ""}
                                onChange={e => {
                                  this.setState({ thursdayStart: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="Start"
                              />
                            </div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.thursdayEnd || ""}
                                onChange={e => {
                                  this.setState({ thursdayEnd: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="End"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="ui-g-12">
                        {!this.state.classOnFriday ? (
                          <div
                            className="ui-g-12"
                            style={{ pointerEvents: "none" }}
                          >
                            <input
                              style={{
                                borderLeftStyle: "hidden",
                                borderColor: "white"
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.fridayStart || ""}
                                onChange={e => {
                                  this.setState({ fridayStart: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="Start"
                              />
                            </div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.fridayEnd || ""}
                                onChange={e => {
                                  this.setState({ fridayEnd: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="End"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="ui-g-12">
                        {!this.state.classOnSaturday ? (
                          <div
                            className="ui-g-12"
                            style={{ pointerEvents: "none" }}
                          >
                            <input
                              style={{
                                borderLeftStyle: "hidden",
                                borderColor: "white"
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.saturdayStart || ""}
                                onChange={e => {
                                  this.setState({ saturdayStart: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="Start"
                              />
                            </div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.saturdayEnd || ""}
                                onChange={e => {
                                  this.setState({ saturdayEnd: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="End"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="ui-g-12">
                        {!this.state.classOnSunday ? (
                          <div
                            className="ui-g-12"
                            style={{ pointerEvents: "none" }}
                          >
                            <input
                              style={{
                                borderLeftStyle: "hidden",
                                borderColor: "white"
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.sundayStart || ""}
                                onChange={e => {
                                  this.setState({ sundayStart: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="Start"
                              />
                            </div>
                            <div className="ui-g-6">
                              <pr.Calendar
                                value={this.state.sundayEnd || ""}
                                onChange={e => {
                                  this.setState({ sundayEnd: e.value });
                                }}
                                timeOnly={true}
                                hourFormat="24"
                                inputStyle={{
                                  width: "100%"
                                }}
                                placeholder="End"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <label>Service: </label>
                    <pr.Dropdown
                      value={this.state.setService || ""}
                      options={serviceOptions}
                      onChange={e => {
                        this.setState({ setService: e.value });
                      }}
                      style={{ width: "50%" }}
                    />
                  </div>
                  <div className="ui-g-12">
                    <label>Room: </label>
                    <pr.Dropdown
                      value={this.state.setRoom}
                      options={this.state.roomOptions}
                      onChange={e =>
                        this.setState({
                          setRoom: e.value
                        })
                      }
                      style={{ width: "50%" }}
                    />
                  </div>
                  <div className="ui-g-12">
                    <label>Instructor(s): </label>
                    <br />
                    <br />
                    <pr.PickList
                      source={this.state.pickListAvailable || []}
                      target={this.state.pickListSelected || []}
                      sourceHeader="Available"
                      targetHeader="Selected"
                      responsive={true}
                      itemTemplate={e => (
                        <span>{e.firstName + " " + e.surname}</span>
                      )}
                      onChange={e => {
                        this.setState({
                          pickListAvailable: e.source,
                          pickListSelected: e.target
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="ui-g-12">
                {(this.state.classOnMonday &&
                  (this.state.mondayStart === "" ||
                    this.state.mondayEnd === "")) ||
                (this.state.classOnTuesday &&
                  (this.state.tuesdayStart === "" ||
                    this.state.tuesdayEnd === "")) ||
                (this.state.classOnWednesday &&
                  (this.state.wednesdayStart === "" ||
                    this.state.wednesdayEnd === "")) ||
                (this.state.classOnThursday &&
                  (this.state.thursdayStart === "" ||
                    this.state.thursdayEnd === "")) ||
                (this.state.classOnFriday &&
                  (this.state.fridayStart === "" ||
                    this.state.fridayEnd === "")) ||
                (this.state.classOnSaturday &&
                  (this.state.saturdayStart === "" ||
                    this.state.saturdayEnd === "")) ||
                (this.state.classOnSunday &&
                  (this.state.sundayStart === "" ||
                    this.state.sundayEnd === "")) ? (
                  <label />
                ) : (
                  <pr.Button
                    label={this.state.setId ? "Re-create Set" : "Create Set"}
                    onClick={() => {
                      this.setState({ loaded: false });
                      this.createSchedule();
                    }}
                    style={{ float: "right" }}
                  />
                )}
                <pr.Button
                  label="Cancel"
                  onClick={() => {
                    window.location = "#/managesets";
                  }}
                  style={{ float: "right" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sets/CreateSets.js